import { useFormikContext } from 'formik'
import React from 'react'
import { Box } from 'rebass'
import { Form } from 'ui'
import { JobFieldGroupRenderer } from './JobFieldGroups'
import {
  JobFieldLowerLevelSelectField,
  JobFieldSelectFn,
} from './JobFieldLowerLevelSelectField'

const JobFieldGroup = JobFieldGroupRenderer<any>()

interface IJobFieldInterestsProps {
  jobFieldValueKey: string
  contentAreaKey: string
  disabled: boolean
  label: string
  description: string
  onDismiss?: (field: string) => any
}

export const JobFieldInterests: React.FC<IJobFieldInterestsProps> = ({
  contentAreaKey,
  description,
  disabled,
  jobFieldValueKey,
  label,
  onDismiss,
}) => {
  const { values, setFieldValue } = useFormikContext<any>()
  const selectAdditionalJobField =
    (index: number): JobFieldSelectFn =>
    (jobField) => {
      const contentAreaJobFields = [...(values[jobFieldValueKey] || [''])]
      contentAreaJobFields[index] = jobField
      setFieldValue(jobFieldValueKey, contentAreaJobFields)
    }

  const handleAddJobField: React.MouseEventHandler = (e) => {
    e.preventDefault()
    setFieldValue(jobFieldValueKey, [...(values[jobFieldValueKey] || []), ''])
  }

  const canAddAnotherJobField = () => {
    const contentAreas = values[contentAreaKey] || []
    if (contentAreas.length === 0) {
      return false
    }
    const lastItem = contentAreas[contentAreas.length - 1] || ''
    return lastItem.length > 0
  }

  const jobFields =
    values.contentAreaJobFields.length > 0 ? values.contentAreaJobFields : ['']

  return (
    <React.Fragment>
      {jobFields.map((jobField: string, index: number) => (
        <Form.Row key={`contentAreaStandards${jobFieldValueKey}${index}`}>
          <Form.Item>
            <JobFieldLowerLevelSelectField
              required={true}
              disabled={disabled}
              name={jobFieldValueKey}
              label={index === 0 ? label : undefined}
              description={index === 0 ? description : undefined}
              value={jobField || ''}
              placeholder="Choose a Category"
              onSelect={selectAdditionalJobField(index)}
              onDismiss={onDismiss ? onDismiss(contentAreaKey) : null}
            />
            {jobField.length > 1 ? (
              <Box width={1} marginTop={-1} marginBottom={2}>
                <JobFieldGroup
                  name={contentAreaKey}
                  disabled={disabled}
                  jobField={jobField || ''}
                />
              </Box>
            ) : null}
          </Form.Item>
        </Form.Row>
      ))}
      {canAddAnotherJobField() ? (
        <Form.AssociatedField>
          <Box marginTop={3} marginBottom={3}>
            <Form.Button appearance="link" onClick={handleAddJobField}>
              Add Another
            </Form.Button>
          </Box>
        </Form.AssociatedField>
      ) : null}
    </React.Fragment>
  )
}
